import React from 'react';
import PropTypes from 'prop-types';
import { Box, MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import countryList from 'react-select-country-list';
import { getCountryCallingCode } from 'libphonenumber-js';

const InternationalPhoneNumber = ({ setCompleteNumber }) => {
  const initialCountryCode = 'ES';
  const initialDialCode = getCountryCallingCode(initialCountryCode);
  const initialCountryLabel = countryList()
    .getData()
    .find(country => country.value === initialCountryCode).label;

  const [selectedCountry, setSelectedCountry] = React.useState(initialCountryCode);
  const [number, setNumber] = React.useState('');
  const [prefix, setPrefix] = React.useState({
    countryCode: initialCountryCode,
    country: initialCountryLabel,
    number: initialDialCode
  });

  const options = countryList()
    .getData()
    .filter(country => {
      try {
        getCountryCallingCode(country.value);
        return true;
      } catch (error) {
        return false;
      }
    });

  const handleChangeCountry = event => {
    const countryCode = event.target.value;
    const dialCode = getCountryCallingCode(countryCode);

    if (dialCode) {
      setPrefix({
        countryCode,
        country: options.find(country => country.value === countryCode).label,
        number: dialCode
      });
      setSelectedCountry(countryCode);
      setCompleteNumber(`+${dialCode}${number}`);
    }
  };

  return (
    <Box sx={{ width: '100%', display: 'flex', alignItems: 'center' }}>
      <FormControl variant="outlined" fullWidth sx={{ mr: 1 }}>
        <InputLabel id="country-selector-label">Select a country</InputLabel>
        <Select
          labelId="country-selector-label"
          value={selectedCountry}
          onChange={handleChangeCountry}
          label="Select a country"
        >
          {options.map(country => {
            try {
              const dialCode = getCountryCallingCode(country.value);
              return (
                <MenuItem key={country.value} value={country.value}>
                  <img
                    src={`https://flagcdn.com/w20/${country.value.toLowerCase()}.png`}
                    alt={country.label}
                    style={{ marginRight: 8 }}
                  />
                  {country.label} {dialCode}
                </MenuItem>
              );
            } catch (error) {
              return null;
            }
          })}
        </Select>
      </FormControl>
      <input
        type="tel"
        value={number}
        onChange={e => {
          setNumber(e.target.value);
          setCompleteNumber(`+${prefix.number}${e.target.value}`);
        }}
        placeholder="Phone number"
        style={{
          padding: '10px',
          width: '100%',
          border: '1px solid #ccc',
          borderRadius: '4px',
          height: '56px'
        }}
      />
    </Box>
  );
};

export default InternationalPhoneNumber;

InternationalPhoneNumber.propTypes = {
  setCompleteNumber: PropTypes.func.isRequired
};
